var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchFilled = function SvgSearchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M14.795 15.853a6.067 6.067 0 1 1 1.06-1.06l3.676 3.676-1.06 1.06zm.838-4.786a4.567 4.567 0 1 1-9.133 0 4.567 4.567 0 0 1 9.133 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearchFilled;